// -----------------------------------------------------------------------------
// Main styles
// -----------------------------------------------------------------------------
import '@/styles/main.scss';
// -----------------------------------------------------------------------------
// Layout-wide styles
// -----------------------------------------------------------------------------
import './layout.scss';
// -----------------------------------------------------------------------------
// Main scripts
// -----------------------------------------------------------------------------
import '@/lib/main';
// -----------------------------------------------------------------------------
// Editor components
// -----------------------------------------------------------------------------
import '@/components/editor-ui';
// -----------------------------------------------------------------------------
// Layout-wide components
// -----------------------------------------------------------------------------
import '@/components/ui';
import '@/components/utils';
// -----------------------------------------------------------------------------
// Layout-wide sections
// -----------------------------------------------------------------------------
import '@/sections';
// -----------------------------------------------------------------------------
// Misc
// -----------------------------------------------------------------------------
import { productVariantSelectorName } from '@/components/ui';
if (window.Cell.template.name === 'product') {
    window.subscribe(`${productVariantSelectorName}.change`, ({ selectedProductVariant }) => {
        // Update the URL `variant` param without reloading the page. Also make sure to replace the
        // history instead of pushing a new state. Otherwise, the user will have to click the back
        // button twice to go back to the previous page.
        const url = new URL(window.location.href);
        url.searchParams.set('variant', selectedProductVariant.id.toString());
        window.history.replaceState({}, '', url.toString());
    });
}
